(function( $ ) {
  
  function setCookie(name,value,days) {
	    if (days) {
	        var date = new Date();
	        date.setTime(date.getTime()+(days*24*60*60*1000));
	        var expires = "; expires="+date.toGMTString();
	    }
	    else var expires = "";
	    document.cookie = name+"="+value+expires+"; path=/";
	}

	function getCookie(name) {
		    var nameEQ = name + "=";
		    var ca = document.cookie.split(';');
		    for(var i=0;i < ca.length;i++) {
		        var c = ca[i];
		        while (c.charAt(0)==' ') c = c.substring(1,c.length);
		        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
		    }
		    return null;
	}
  
	var preview = getCookie('preview');
    
    
	var animatePreloader = new TimelineMax();
  
  	if($('.template-index').length && !preview ) {
  		animatePreloader
			.set($('.preloader-wrapper .preloader-icon'), {visibility:"visible"})
			.fromTo($('.preloader-logo-icon .st0'), 3, {drawSVG: 0}, {ease: Power1.easeInOut, drawSVG: '100%'})
			.fromTo($('.preloader-logo-icon .st1'), 3, {drawSVG: 0}, {ease: Power1.easeInOut, drawSVG: '100%'},'-=3')
			.fromTo($('.preloader-logo-icon .st2'), 3, {drawSVG: 0}, {ease: Power1.easeInOut, drawSVG: '100%'}, '-=3')
			.to($('.preloader-logo-icon .st0'), 3, {strokeWidth: 0, fill: '#F15A2D'}, '-=1')
			.to($('.preloader-logo-icon .st2'), 3, {strokeWidth: 0, fill: '#211E1F'}, '-=3')
			.staggerFrom($('.preloader-logo-icon .st3'), 0.3, {opacity: 0, ease: Power1.easeInOut}, 0.05, '-=3')
    		.to($('.preloader-wrapper'), 3, {delay: 2, opacity: 0, ease: Power0.easeNone}, '-=6')
			.set($('.preloader-wrapper'), {className:"+=pre-hidden"}, '-=1')
			.set($('html'), {overflow: 'visible'}, '-=1');
    		setCookie('preview', '1', 1 );
  
  	}
  	else {
    	$('html').css('overflow', 'visible');
  		$('.preloader-wrapper').removeClass('pre-hidden').css('display', 'none');
  	}
  
	

})(jQuery);	


	